import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { Theme } from '../../enums/theme.enum';
import * as ConfigActions from './config.actions';
import { DateTime } from 'luxon';

export const configFeatureKey = 'config';

export interface State extends EntityState<any> {
  // additional entities state properties
  sidenavOpen: boolean;
  //language: string;
  theme: Theme;
  nextTosSkipTimestamp: number | null;
  error: any;
}

export const adapter: EntityAdapter<any> = createEntityAdapter<any>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  sidenavOpen: true,
  theme: Theme.AUTO,
  nextTosSkipTimestamp: null,
  error: null,
});

export const configReducer = createReducer(
  initialState,
  on(ConfigActions.toggleSidenav, (state) => ({ ...state, sidenavOpen: !state.sidenavOpen })),
  on(ConfigActions.openSidenav, (state) => ({ ...state, sidenavOpen: true })),
  on(ConfigActions.closeSidenav, (state) => ({ ...state, sidenavOpen: false })),
  on(ConfigActions.toggleTheme, (state, action) => {
    const themeSwitch = (theme: Theme) => {
      switch (theme) {
        case Theme.AUTO: {
          return Theme.LIGHT;
        }
        case Theme.LIGHT: {
          return Theme.DARK;
        }
        case Theme.DARK: {
          return Theme.AUTO;
        }
      }
    };
    return { ...state, theme: themeSwitch(state.theme) };
  }),
  on(ConfigActions.setTheme, (state, action) => ({ ...state, theme: action.theme })),
  on(ConfigActions.skipTos, (state) => ({
    ...state,
    nextTosSkipTimestamp: DateTime.now().plus({ hours: 6 }).toSeconds(),
  })),
  on(ConfigActions.resetTosSkip, (state) => ({ ...state, nextTosSkipTimestamp: null }))
);

export const selectConfigState = createFeatureSelector<State>(configFeatureKey);

export const selectSidenavOpen = createSelector(selectConfigState, (state) => state.sidenavOpen);
export const selectTheme = createSelector(selectConfigState, (state) => state.theme);
export const selectTosSkip = createSelector(selectConfigState, (state) =>
  DateTime.fromSeconds(state.nextTosSkipTimestamp ?? 0 / 1000)
);
